export const dataWaterLevel = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  datasets: [
    {
      label: '水位',
      data: [] as string[] | number[] | null[],
      fill: true,
      backgroundColor: 'rgba(75,192,192,0.2)',
      borderColor: 'red',
      yAxisID: 'y',
    },
  ],
};

export const dataVelocity = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  datasets: [
    {
      label: '流量',
      data: [] as string[] | number[] | null[],
      fill: true,
      backgroundColor: 'rgba(75,192,192,0.2)',
      borderColor: '#015CAC',
      yAxisID: 'y',
    },
  ],
};

export const configWaterLevel = {
  type: 'line',
  data: dataWaterLevel,
  options: {
    maintainAspectRatio: false,
    responsive: true,
    // height: 300,
    title: {
      display: false,
      text: '',
    },
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: '年',
          },
          ticks: {
            max: 100,
            min: 0,
          },
        },
      ],
      yAxes: [
        {
          id: 'y',
          scaleLabel: {
            display: true,
            labelString: '水位 (m)',
            color: 'red',
            fontColor: 'red',
          },
          color: 'red',
          name: 'Flow',
          type: 'linear',
          position: 'right',
          scalePositionLeft: false,
          ticks: {
            color: 'red',
            fontColor: 'red',
            max: 300,
            min: -200,
          },
        },
      ],
    },
    tooltips: {
      mode: 'nearest',
      intersect: false,
    },
    hover: {
      mode: 'nearest',
      intersect: false,
    },
  },
};


export const configVelocity = {
  type: 'line',
  data: dataVelocity,
  options: {
    maintainAspectRatio: false,
    responsive: true,
    // height: 300,
    title: {
      display: false,
      text: '',
    },
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: '年',
          },
          ticks: {
            max: 100,
            min: 0,
          },
        },
      ],
      yAxes: [
        {
          id: 'y',
          scaleLabel: {
            color: '#015CAC',
            fontColor: '#015CAC',
            display: true,
            labelString: '流量 (m3/s)',
          },
          scalePositionLeft: true,
          position: 'right',
          ticks: {
            color: '#015CAC',
            fontColor: '#015CAC',
            max: 10,
            min: 0,
          },
        },
      ],
    },
    tooltips: {
      mode: 'nearest',
      intersect: false,
    },
    hover: {
      mode: 'nearest',
      intersect: false,
    },
  },
};
